/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCloud(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M7.971 3.325c4.378-.587 8.3 2.348 9.192 5.968h.38c2.744 0 4.635 1.251 5.563 3.014.908 1.728.846 3.866-.122 5.574-.732 1.29-1.655 2.04-2.792 2.441-1.09.384-2.33.428-3.646.428H9.068c-4.836 0-8.132-3.744-8.718-7.607-.667-4.4 2.04-9.07 7.621-9.818zm9.572 7.468c2.242 0 3.591.99 4.235 2.213.662 1.26.626 2.855-.099 4.135-.567 1-1.215 1.495-1.985 1.766-.82.289-1.821.343-3.148.343H9.068c-3.976 0-6.742-3.08-7.235-6.332C1.28 9.28 3.486 5.44 8.17 4.812c3.849-.516 7.195 2.275 7.633 5.337a.75.75 0 00.742.644h.997z'
      />
    </svg>
  );
}

export default SvgCloud;
